import { trimmedStringFromUnknown } from "../protocol/shared.js";
import { openMeldRuntimeProfileIdSchema } from "../protocol/profile.js";
import { messageEnvelopeSchema } from "../protocol/message-envelope.js";
import { spaceThreadContextSchema } from "./space-thread.js";
import { agentControllerConversationRefSchema } from "../daemon/conversation-contract.js";
import { dispatchExecutionSchema } from "../daemon/conversation-lifecycle.js";
import { spaceStatusSchema } from "./signal-status.js";
import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/dispatch-result.ts
const isoDateTimeSchema = z$1.iso.datetime({ offset: true });
const nullableTrimmedStringSchema = z$1.union([z$1.string().trim().min(1), z$1.null()]);
const dispatchResultKindSchema = z$1.enum(["text", "status"]);
const dispatchResultPublicOutcomeSchema = z$1.enum([
	"internal_only",
	"raw_context_sharing",
	"system_notice",
	"stay_silent",
	"post_message",
	"post_status"
]);
const dispatchResultRuntimeWorkspaceSchema = z$1.strictObject({
	fingerprint: nullableTrimmedStringSchema,
	path: z$1.string().trim().min(1)
});
const dispatchResultSchema = z$1.strictObject({
	resultRef: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	dispatchId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	spaceId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	actorProfileId: openMeldRuntimeProfileIdSchema,
	actorName: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	replyToSignalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	resultKind: dispatchResultKindSchema,
	finalText: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	messageEnvelope: messageEnvelopeSchema.optional(),
	threadContext: spaceThreadContextSchema.optional(),
	statusType: spaceStatusSchema.optional(),
	previewText: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	publicOutcome: dispatchResultPublicOutcomeSchema,
	agentControllerConversation: agentControllerConversationRefSchema.optional(),
	runtimeWorkspace: dispatchResultRuntimeWorkspaceSchema.optional(),
	dispatchExecution: dispatchExecutionSchema.optional(),
	publishedSignalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)).optional(),
	createdAt: isoDateTimeSchema
}).superRefine((value, ctx) => {
	if (value.resultKind === "text" && !value.finalText) ctx.addIssue({
		code: "custom",
		message: "finalText is required when resultKind is text",
		path: ["finalText"]
	});
	if (value.resultKind === "status" && !value.statusType) ctx.addIssue({
		code: "custom",
		message: "statusType is required when resultKind is status",
		path: ["statusType"]
	});
	if (value.messageEnvelope && value.resultKind !== "text") ctx.addIssue({
		code: "custom",
		message: "messageEnvelope is only allowed when resultKind is text",
		path: ["messageEnvelope"]
	});
	if (value.messageEnvelope && value.finalText && value.finalText !== value.messageEnvelope.text) ctx.addIssue({
		code: "custom",
		message: "messageEnvelope.text must match finalText",
		path: ["messageEnvelope", "text"]
	});
	if (value.messageEnvelope?.replyToSignalId && value.replyToSignalId && value.replyToSignalId !== value.messageEnvelope.replyToSignalId) ctx.addIssue({
		code: "custom",
		message: "messageEnvelope.replyToSignalId must match replyToSignalId",
		path: ["messageEnvelope", "replyToSignalId"]
	});
});
//#endregion
export { dispatchResultKindSchema, dispatchResultPublicOutcomeSchema, dispatchResultRuntimeWorkspaceSchema, dispatchResultSchema };

//# sourceMappingURL=dispatch-result.js.map